export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "Personal Loan Eligibility Calculator - Check Your Loan Eligibility Instantly",
    subHeading:
      "Have you checked your borrowing potential using Minemi's Personal Loan Eligibility Calculator? With your results in hand, let’s explore how they reflect your financial standing and the steps you can take to boost your loan approval prospects.",

    notice:
      "This page will guide you through the factors affecting personal loan eligibility, help you interpret your results, and offer actionable tips to secure the best loan terms.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
